import React, { useMemo } from "react";
import { Link } from "umi";
import { getUrlParams } from "@/utils/utils";
import { pathsWithRequiredParams } from "./constants";
const BreadcrumbItem = ({ breadcrumbName }, params, routes, paths) => {
    const linkPath = useMemo(() => (paths.length > 0 ? `/${paths[paths.length - 1]}` : "/"), [paths]);
    const stringParams = useMemo(() => {
        if (!pathsWithRequiredParams[linkPath]) {
            return "";
        }
        const requiredParams = pathsWithRequiredParams[linkPath];
        const urlParams = new URLSearchParams(getUrlParams(requiredParams));
        return urlParams.toString();
    }, [linkPath]);
    return React.createElement(Link, { to: `${linkPath}?${stringParams}` }, breadcrumbName);
};
export default BreadcrumbItem;
